(function () {
  'use strict';

  function scrollToReviewSection() {
    var target = document.getElementById('tab_product')
      || document.getElementById('judgeme_product_reviews')
      || document.querySelector('.jdgm-rev-widg');
    if (!target) return;

    var stickyHeader = document.querySelector('.header-fixed.sticky-header, .ntheader_wrapper.sticky-header');
    var stickyOffset = stickyHeader && stickyHeader.offsetParent !== null ? stickyHeader.offsetHeight : 0;
    var top = target.getBoundingClientRect().top + window.pageYOffset - stickyOffset - 20;

    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function openReviewTab() {
    var tabLink = document.querySelector('#tab_product a[href="#tab_review"]');
    if (tabLink) tabLink.click();
  }

  function isInsideProductCard(el) {
    return !!(el.closest && el.closest('.product-item, .product-card, .alo-prev-next-products, .productLazyload'));
  }

  function onClick(e) {
    if (!document.body.classList.contains('template-product')) return;

    var target = e.target;
    if (!target || !target.closest) return;

    var badge = target.closest('.jdgm-preview-badge, .jdgm-prev-badge, .write-review');
    if (!badge) return;

    if (isInsideProductCard(badge)) return;

    e.preventDefault();
    e.stopPropagation();

    openReviewTab();
    setTimeout(scrollToReviewSection, 50);
  }

  document.addEventListener('click', onClick, true);

  window.__alo_pdpStarHandler = 'standalone-v1';
})();
